import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDhqdwyzYYDoawU-qYJXGZFblWyfEJnft4",
  authDomain: "hookora-1010.firebaseapp.com",
  projectId: "hookora-1010",
  storageBucket: "hookora-1010.firebasestorage.app",
  messagingSenderId: "892980863405",
  appId: "1:892980863405:web:bb952044ebc98564924124"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);


